import { render, staticRenderFns } from "./OffersNew.vue?vue&type=template&id=fbd204c2&"
import script from "./OffersNew.vue?vue&type=script&lang=js&"
export * from "./OffersNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports